/**
 * Created by asiulik on 15.05.2017.
 */

define(['jquery', 'lodash', '../core/page/pageHistory'], function ($, _, History) {

  function TabsExtender ($finder, layoutInstace) {
    this.history = new History();
  }

  TabsExtender.prototype.init = function () {
    var _this = this;
    $('.tabs > li.tab > a').on('click', function() {
      var tabHref = document.createElement('a');
      tabHref.href = $(this).attr('href');

      var documentHref= new URL(document.location);
      documentHref.hash = tabHref.hash;
      _this.history.updateHistory(documentHref.href);
    })
  }

  return TabsExtender;

});


// WEBPACK FOOTER //
// ./Private/Scripts/materialize-modify/tabs-extender.js